import React from 'react';
import { Modal, Box, Typography } from '@mui/material';

interface ChangeLogModalProps {
  open: boolean;
  onClose: () => void;
  changeLog: string;
}

const ChangeLogModal: React.FC<ChangeLogModalProps> = ({
  open,
  onClose,
  changeLog,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          // Centred like every other modal in the panel. `top: 70%` with
          // `right: 1px` pinned this one to the bottom right corner, which
          // read as a stray popup rather than a dialog.
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          borderRadius: 1,
          boxShadow: 24,
          p: 16,
          m: 8,
        }}
      >
        <Typography
          id="modal-title"
          variant="h6"
          component="h2"
          sx={{
            textAlign: 'center',
            color: '#25282E',
            fontSize: 16,
            fontFamily: 'IRANYekanXFaNum',
          }}
        >
          تغییرات نسخه
        </Typography>
        <Typography
          id="modal-description"
          sx={{
            m: 16,
            color: '#60646E',
            fontSize: 12,
            fontFamily: 'IRANYekanXFaNum',
            lineHeight: '20px',
            wordWrap: 'break-word',
            alignContent: 'center',
            textAlign: 'right',
          }}
        >
          {changeLog || 'برای این نسخه توضیحی ثبت نشده است.'}
        </Typography>
      </Box>
    </Modal>
  );
};

export default ChangeLogModal;
